import styled from '@emotion/styled'
import { Divider, Stack, Typography } from '@mui/material'
import { COLORS } from 'app-constants'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'

export const PageContainerStack = styled(Stack)`
  border-left: 1px solid #ddd;
  width: 100%;
  height: 100vh;
  padding: 24px;
  background-color: #f8f8f8;
`

const DataAndPrivacy = () => {
  const isMobile = useCheckMobileScreen()

  return (
    <PageContainerStack>
      {!isMobile && (
        <Typography variant="h4" mb={3}>
          Data & Privacy
        </Typography>
      )}
      <Typography
        mb={5}
        variant="pS"
        sx={{
          color: COLORS.GRAY_2,
        }}>
        Manage your third-party connections to Google and Slack.{' '}
        <a
          href="https://jelled.ai/security"
          target="_blank"
          rel="noreferrer"
          style={{
            textDecoration: 'underline',
          }}>
          Learn more
        </a>{' '}
        about how we secure your data.
      </Typography>

      <Typography variant="h5" mb={1}>
        Google
      </Typography>
      <Typography
        variant="pXS"
        sx={{
          color: COLORS.GRAY_2,
        }}>
        <a
          href="https://myaccount.google.com/connections"
          target="_blank"
          rel="noreferrer"
          style={{
            textDecoration: 'underline',
          }}>
          Manage Jelled.ai access to your Google account
        </a>{' '}
        (including emails, Google Calendar, and Drive).
      </Typography>

      <Divider
        sx={{
          my: 4,
        }}
      />

      <Typography variant="h5" mb={1}>
        Slack
      </Typography>
      <Typography
        variant="pXS"
        sx={{
          color: COLORS.GRAY_2,
        }}>
        <a
          href="https://slack.com/help/articles/1500009181142-Manage-app-settings-and-permissions"
          target="_blank"
          rel="noreferrer"
          style={{
            textDecoration: 'underline',
          }}>
          Manage Jelled.ai access to your Slack account
        </a>{' '}
        (including read or write access).
      </Typography>
    </PageContainerStack>
  )
}

export default DataAndPrivacy
